import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "basicLayout" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "content-wrapper" }

import { ref, watch } from "vue";
import { routes } from "@/router/router";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const activeIndex = ref(route.path);
const menuItems = routes;

const handleSelect = (key: string) => {
  router.push(key);
};

// 监听路由变化，更新 activeIndex
watch(
  () => route.path,
  (newPath) => {
    activeIndex.value = newPath;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "company-logo" }, [
        _createElementVNode("img", {
          style: {"width":"60px","height":"60px"},
          src: _imports_0,
          alt: "如赛通"
        }),
        _createTextVNode(" 如赛通 ")
      ], -1)),
      _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        ellipsis: false,
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (menuItem) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              index: menuItem.path,
              key: menuItem.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(menuItem.name), 1)
              ]),
              _: 2
            }, 1032, ["index"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer" }, [
      _createElementVNode("p", null, "版权所有 © 2025 深圳市如赛通科技有限公司")
    ], -1))
  ]))
}
}

})